import { render, staticRenderFns } from "./DocumentIcon.vue?vue&type=template&id=adba3216"
import script from "./DocumentIcon.vue?vue&type=script&lang=js"
export * from "./DocumentIcon.vue?vue&type=script&lang=js"
import style0 from "./DocumentIcon.vue?vue&type=style&index=0&id=adba3216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports